// MassBuildingUnitCleaningManagement.jsx
import React from "react";
import { Divider, Tabs } from "antd";
import CleaningListComplex from "../../Cleanings/CleaningListComplex";
import BuildingUnitLink from "../BuildingUnitLink";
import PartnerLink from "../../Partners/PartnerLink";
import { useTranslation } from "react-i18next";

const MassBuildingUnitCleaningManagement = ({ buildingUnits = [], partners = [] }) => {
  const { t } = useTranslation();
  const hasPartners = partners.length > 0;
  const hasUnits = buildingUnits.length > 0;

  const items = [];

  if (hasPartners) {
    items.push({
      key: "partners",
      label: t("common.byPartners"),
      children: (
        <div>
          {partners.map((partner) => (
            <div key={partner.id} style={{ marginBottom: 24 }}>
              <Divider orientation="left">
                <PartnerLink partner={partner}/>
              </Divider>
              <CleaningListComplex partner={partner} showMassClaimButton={false}/>
            </div>
          ))}
        </div>
      ),
    });
  }

  if (hasUnits) {
    items.push({
      key: "units",
      label: t("common.byUnits"),
      children: (
        <div>
          {buildingUnits.map((unit) => (
            <div key={unit.id} style={{ marginBottom: 12 }}>
              <Divider orientation="left">
                {unit.district} <BuildingUnitLink buildingUnit={unit} />
              </Divider>
              <CleaningListComplex buildingUnit={unit} />
            </div>
          ))}
        </div>
      ),
    });
  }

  if (!items.length) return null;

  return <Tabs defaultActiveKey={hasPartners ? "partners" : "units"} items={items} />;
};

export default MassBuildingUnitCleaningManagement;
